import { type MutationTree } from 'vuex';

import { type IAgreementState } from './types';

export const RECEIVE_MOST_RECENT_CDA = 'receiveMostRecentCDA';

export const mutations: MutationTree<IAgreementState> = {
    [RECEIVE_MOST_RECENT_CDA](_state: IAgreementState, { leadId, cdaId }: { leadId: number; cdaId: number }) {
        _state.mostRecentCDA.set(leadId, cdaId);
    }
};
